
const product = {
  color: '#074e8c', 
  favicon: require(`../@theme/images/xc/favicon.ico`), /**require path cannot be dynamic */
  title: 'Xpress Cover', 
};

export default product;